import React from 'react'
import BackOffice from '../src/Layout/backoffice'
import 'typeface-montserrat'
import { AUTH0_CONFIGURATION } from './auth/authconstants'
import getTranslations from './configuration/getTranslations'
import getTheme from './configuration/getTheme'
import getRoutes from './configuration/getRoutes'
import getMenuItems from './configuration/getMenuItems'
import getAvatarMenuItems from './configuration/getAvatarMenuItems'
import getAppbarOptions from './configuration/getAppbarOptions'
import getLogos from './configuration/getLogos'

const App = () => {    
  return (
    <BackOffice
      getLogos={getLogos}
      getRoutes={getRoutes} //mandatory
      getMenuItems={getMenuItems} //mandatory
      getAppbarOptions={getAppbarOptions} //optional
      getTheme={getTheme} //optional
      getTranslations={getTranslations} //optional
      locale='nl' //optional
      authConfiguration={AUTH0_CONFIGURATION} //optional
      getAvatarMenuItems={getAvatarMenuItems} //optional
    />
  )
}

export default App
